import { Col, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { FilePdfOutlined, DownloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

export default function PDFViewer({ fileName,title = "Document / दस्तावेज़" }) {
  const { i18n } = useTranslation();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [error, setError] = useState(false);
  const [lang, setLang] = useState(localStorage.getItem("language") === "en" ? 2 : 1);

  // language change
  useEffect(() => {
    setLang(localStorage.getItem("language") === "en" ? 2 : 1);
  }, [i18n.language]);

  // screen resize detect
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {isMobile || error ? (
        <Row className="g-4">
          <Col md={6}  xs={12}>
            <a
              href={fileName}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <div className="report-card text-center p-3">
                <div className="report-thumb mt-2 mb-3">
                  <FilePdfOutlined
                    style={{ fontSize: "60px", color: "#ff4d4f" }}
                  />
                </div>
<h6 className="mb-3">{title}</h6>
                <span>
                  <DownloadOutlined />{" "}
                  {lang === 2 ? "View / Download" : "देखें / डाउनलोड"}
                </span>
              </div>
            </a>
          </Col>
        </Row>
      ) : (
        <iframe
          src={fileName}
          title="PDF Viewer"
          width="100%"
          height="600"
          style={{ border: "1px solid #ddd", borderRadius: "8px" }}
          onError={() => setError(true)}
        />
      )}
    </>
  );
}



// import { Col, Row } from "react-bootstrap";
// import { useEffect, useState } from "react";
// import { FilePdfOutlined, DownloadOutlined } from "@ant-design/icons";
// import { useTranslation } from "react-i18next";
// export default function PDFViewer({ fileName }) {
//   const [isMobile, setIsMobile] = useState(false);
//   const {  i18n } = useTranslation();
//   const [error, setError] = useState(false);
//   const [lang, setLang] = useState(localStorage.getItem('language') === "en" ? 2 : 1);
//   useEffect(() => {
//     setLang(localStorage.getItem('language') === "en" ? 2 : 1);
//   }, [i18n.language]);
//   useEffect(() => {
//     setIsMobile(window.innerWidth <= 768);
//   }, []);

//   return (
//     <>
//       {isMobile || error ? (

//         <Row className="g-4">

//           <Col md={4} sm={6} xs={12} >
//             <a
//               style={{ textDecoration: "none" }}
//               href={fileName}
//               target="_blank" rel="noopener noreferrer"
//             >
//               <div className="report-card text-center p-3">


//                 <div className="report-thumb mt-2 mb-3">
//                   <FilePdfOutlined style={{ fontSize: "60px", color: "#ff4d4f" }} />
//                 </div>

//                 {/* <h6 className="mb-3">kishan</h6> */}

//                 <span className="">
//                   <DownloadOutlined /> {lang === 2 ? "View / Download" : "देखें / डाउनलोड"}
//                 </span>


//               </div>
//             </a>

//           </Col>


//         </Row>
//       ) : (
//         <iframe
//           src={fileName}
//           title="PDF Viewer"
//           width="100%"
//           height="600"
//            onError={() => setError(true)}
//         />
//       )}
//     </>
//   );
// }




// import React from 'react';
// import { pdfjs} from 'react-pdf'
// import { Worker, Viewer } from '@react-pdf-viewer/core';
// import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
// import '@react-pdf-viewer/core/lib/styles/index.css';
// import '@react-pdf-viewer/default-layout/lib/styles/index.css';

// export default function PDFViewer(props) {
//   const defaultLayoutPluginInstance = defaultLayoutPlugin();
//   const viewerStyle = {
//     width: '100%',
//     height: '600px',
//   };

//   return (
//     <div style={viewerStyle}>
//       <Worker workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`}>
//         <Viewer fileUrl={props.fileName} plugins={[defaultLayoutPluginInstance]} />
//       </Worker>
//     </div>
//   );
// }
